module.exports = __webpack_public_path__ + "img/google.8f1364f5.svg";